<template>
  <el-dialog
    title="排重"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    width="989px"
    @close="close"
  >
    <el-form
      :model="uniqueForm"
      :label-width="'auto'"
      status-icon
      :rules="rules"
      :disabled="isReadOnly"
      ref="ruleForm"
    >
      <el-form-item label="节点名称：" prop="name">
        <el-input
          v-model="uniqueForm.name"
          show-word-limit
          maxlength="50"
          class="node-name"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="排重优先级">
        <el-alert
           title="拖动节点名称可修改优先级"
           :closable="false"
           type="info"
           show-icon>
         </el-alert>
          <!-- 升级 -->
          <div class="clickClass">
            <el-button type="primary" @click="resetNoteName" style="width:135px">重置输出节点名称</el-button>
         </div>
        <el-table
          :data="uniqueForm.excludeRepeatNode.removeDuplicateNodeList"
          border
          class="uploadTable"
          :empty-text="'请先连入节点'"
          row-key="inputNodeId"
          max-height="380px"
        >
          <el-table-column
            prop="sort"
            width="70"
            label="优先级"
          ></el-table-column>
          <el-table-column
            prop="inputNodeName"
            width="274"
            label="输入节点名称"
          ></el-table-column>
          <el-table-column
            prop="outNodeName"
            label="输出节点名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.outNodeName"
                placeholder="请输入输出节点名称"
                style="100%"
                show-word-limit
                maxlength="50"
                class="input-node"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="inputNodeId"
            align="center"
            width="172"
            label="调整优先级"
          >
            <template slot-scope="scope" >
              <div  class="buttongroup">
                <el-button class="operate-btn" type="text" @click="handelSort(scope.$index, 'up')">上移</el-button>
                <el-button class="operate-btn" type="text" @click="handelSort(scope.$index, 'down')">下移</el-button>
                <el-button class="operate-btn" type="text" @click="handelSort(scope.$index, 'top')">置顶</el-button>
                <el-button class="operate-btn" type="text" @click="handelSort(scope.$index, 'bottom')">置底</el-button>
             </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" v-loading="loading" :disabled="isReadOnly" @click="uniqueSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
import Sortable from 'sortablejs'
export default {
  name: "uniqueDialog",
  data() {
    return {
      loading: false,
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      uniqueForm: {
        name: "",
        excludeRepeatNode: {
          removeDuplicateNodeList: [],
        },
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  components: {},
  created () {
    mnode.getNode({nodeId: this.nodeId}).then(res => {
      if (res.code === 1 && res.data.name) {
        this.uniqueForm.name = res.data.name
        if (res.data.removeDuplicateNodeList && res.data.removeDuplicateNodeList.length > 1) {
          res.data.removeDuplicateNodeList.map((i,index)=>i.sort = index+1)
          this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList = res.data.removeDuplicateNodeList
        }
        this.rowDrop()
      }
    })
  },
  methods: {
    //升级--重置输出节点名称
    resetNoteName(e){
      this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.map((e,index)=>{
         e.outNodeName = e.inputNodeName
      })
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.splice(oldIndex, 1)[0]
          _this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.splice(newIndex, 0, currRow)
          _this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.forEach((e,i)=>{
            e.sort = i+1
          })
        }
      })
    },
    //确定
    uniqueSubmit () {
       if (this.loading) {
        return;
      }
      
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify()
          let dataremove = {}
          dataremove.name=data.name;
          dataremove.nodeId=data.nodeId;
          dataremove.removeDuplicateNodeRules=data.excludeRepeatNode.removeDuplicateNodeList;
          if (dataremove) {
            this.loading = true;
            mnode.updateDetailremoveDup(dataremove).then(res => {
              this.loading = false;
              if (res.code === 1) {
                // this.viewVisible = false
                this.$emit('change', {})
                this.$emit('change-name', dataremove)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    //关闭
    close() {
      this.viewVisible = false;
    },
    handelSort (index, type) {
      let list = JSON.parse(JSON.stringify(this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList))
      let row = list[index]
      let trow
      let l
      switch (type) {
        case 'up':
          if (index === 0) {
            return
          }
          l = index - 1
          break
        case 'down':
          if (index === this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList - 1) {
            return
          }
          l = index + 1
          break
        case 'top':
          if (index === 0) {
            return
          }
          l = 0
          break
        case 'bottom':
          l = this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.length - 1
          if (index === l) {
            return
          }
          break
      }
      row.sort = l + 1
      trow = list[l]
      trow.sort = index + 1
      if(type === 'bottom') {
        this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.push(row)
        this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.splice(index,1)
        this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.forEach((e,i)=>{
          e.sort = i + 1
        })
      }else if(type == 'top'){
        this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.unshift(row)
        this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.splice(index+1,1)
        this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.forEach((e,i)=>{
          e.sort = i + 1
        })
      }else{
        this.$set(this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList, l, row)
        this.$set(this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList, index, trow)
      }
    },
    getDataify () {
      let data = JSON.parse(JSON.stringify(this.uniqueForm))
      if (data.excludeRepeatNode.removeDuplicateNodeList.some(i => i.outNodeName.length === 0 || i.outNodeName.length > 50)) {
        this.$message.error('输出节点名称必填且小于50个字！')
        return false
      }
      data.nodeId = this.$props.nodeId
      return data
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table .el-table__header-wrapper th .cell{
   color: #333;
   font-weight: 600;
}
/deep/ .flag {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right:0;
}

.buttongroup{
  display: flex; 
  align-items: center;
  justify-content: space-between;
  .title{
    font-size: 12px;
    cursor: pointer;
  }
}

.clickClass {
  margin-bottom: 16px;
  margin-top: 16px;
}

.node-name{
  width: 346px;
  /deep/.el-input__inner{
    padding-right: 50px;
  }
}
.input-node{
  /deep/.el-input__inner{
    padding-right: 50px;
  }
}
.tip{
  margin-bottom: 16px;
  padding: 0px 14px;
}
.operate-btn{
  width: auto;
  padding: 0px!important;
}
</style>
